export const NEW_BUTTON_ENTRY_SOURCE = 'NewButton';
export const KEYBOARD_SHORTCUT_ENTRY_SOURCE = 'KeyboardShortcut';
export const NEW_BUTTON_ANCHOR_NAME = 'NewEventButtonAnchor';
export const NEW_BUTTON_ANCHOR = '#' + NEW_BUTTON_ANCHOR_NAME;
